import { Header } from 'components/molecules';
import { VerificationTemplate } from 'components/templates';
import { GET_PROCESS } from 'const';
import { withAuth } from 'HOCs';
import { useBreadcrumbs, useGet } from 'hooks';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Process } from 'types';
import { saveState } from 'utils';

const TransactionPageVerification = () => {
  const { id } = useParams();
  const [breadcrumbs, title] = useBreadcrumbs();

  const { data: process } = useGet<Process>(GET_PROCESS.replace(':id', id as string));

  useEffect(() => {
    if (process) {
      saveState('currentProcess', process);
    }
  }, [process]);

  return (
    <>
      <Header
        title={title}
        subtitle={`Corrige las ${breadcrumbs[0]?.toLocaleLowerCase()}`}
        breadCrumbsProps={{
          breadcrumbs,
        }}
      />
      <VerificationTemplate key={id} id={id as string} />
    </>
  );
};

export default withAuth(TransactionPageVerification);
